import ApiServer from "../ApiServer.js";
import * as Html from "../util/Html.ts";
import * as i18n from "../i18n.ts";
import FizConfig from "../FizConfig.js";
import {ColorCache} from "../server/objects/ColorBean.js";
import Icons from "../svg/Icons.ts";

export {init}
Html.registerWidget('widget/color-picker',{init:init})

function init(obj){
  var 
    visibilityPilot = obj.parents('form').get(0)[obj.attr('data-visibility-pilot')],
    defaultColor = obj.attr('data-default-color'),
    currentColor = obj.attr('data-color');


  $(visibilityPilot).on('change',function(){
    if(this.value==='true'){
      obj.show(0)
    }else{
      obj.hide(0)
    }
  }).trigger('change')
  
  function rewriteColor(colorsFromDb){
    var 
      result = [];
    if(defaultColor){
      result.push({cc:defaultColor,name:i18n.get('color.default'),metaId:'color/-0',isDefault:true})
    }else{
      result.push({cc:FizConfig.defaultColor,name:i18n.get('color.default'),metaId:'color/-0',isDefault:true})
    }
    if(currentColor && !colorsFromDb.find(c=>c.cc===currentColor) && !result.find(c=>c.cc===currentColor)){
      //if the currentcolor is not in the list we replace the first one by the current
      result.pop();
      result.push({cc:currentColor,name:i18n.get('color.default'),metaId:'color/-1',isDefault:true})
    }
    
    result = result.concat(colorsFromDb.filter(colorBean=>colorBean.cc!==result[0].cc));
    return result;
    
  }
  if(obj.attr('data-colors')){
    initWithColors(obj,obj.attr('data-colors').split(',').map((str,idx)=>{return {cc:str,metaId:idx}}));
  }else {
    ColorCache.need().then(colorsFromDb=>{
      initWithColors(obj,rewriteColor(colorsFromDb))
    })
  }
  
}

function initWithColors(obj,colors){
  var 
    emptyDefault = obj.attr('data-default')==='empty',
    form = obj.parents('form'),
    inputedColorString = obj.attr('data-color')||'',
    color = colors.filter(c=>c.cc===inputedColorString.toUpperCase())[0]||colors[0],
    context = {
      title:i18n.get('color.title'),
      selected:color,
      colors:colors,
      showhead:obj.data('showhead'),
      showname:true  //FIXME should be taken from obj.data();
    }

  function display(){
    let head = `
      <span class="label">${context.title}</span> : <span class="color-picker-text" data-fw-meta-id="${context.selected.metaId}" style="padding:0 8px 0 2px;cursor:pointer;color:${context.selected.cc};display:${context.showname?'inline-block':'none'}">${Html.escape(context.selected.name)}</span>
      ${context.selected.isDefault?'':`<i style="cursor:pointer;font-size:inherit;position:relative;top:-4px;left:-5px;color:${context.selected.cc}">${Icons.ic_edit}</i>`}
      <br/>`
    
    let colorByLines = [];
    if(context.colors.length>15){
      let half = Math.ceil(context.colors.length/2);
      colorByLines.push(context.colors.slice(0,half));
      colorByLines.push(context.colors.slice(half));
    }else{
      colorByLines.push(context.colors);
    }

    obj.html(`<input name="color" type="hidden" value="${emptyDefault?(context.selected.isDefault?'':context.selected.cc):context.selected.cc}">
      ${context.showhead?head:''}
      ${colorByLines.map(colors=>`
        <ul class="color-picker" style="margin-bottom:5px">
          ${colors.map(c=>`
            <li ${c.isDefault?`data-color-default="true"`:''} data-color-name="${Html.escape(c.name)}" data-color="${c.cc}" style="border-color:${c.cc};background-color:${c===context.selected?c.cc:''}" data-fw-meta-id="${c.metaId}"></li>
          `).join('')}
         </ul>
      `).join('')}     
    `)
    //if external change of the hidden color input
    obj.find('input').on('change',function(){
      obj.find("li[data-color='"+this.value+"']").trigger('click')
    })
    //change data
    form.css('--picked-color',context.selected.cc)
  }
  display();
  obj.on('click','li',function(){
    context.selected = colors.filter(c=>c.metaId==$(this).metaId())[0];
    display();
  })
  obj.on('click','i, .color-picker-text',function(){
    let theNode = $(obj).find('.color-picker-text');
    if(theNode.prop('contenteditable')==='true') return;
    if(context.selected.isDefault) return;
    
    theNode.prop('contenteditable',true).on('keydown paste', function(event) { //emulate maxlength
      if($(this).text().length >= 30 && [37,39,8,46,10,13].indexOf(event.keyCode)== -1) { //allowed keycode 37 39 => arrow 8=>delete 46=>suppr 10,13=>return
        event.preventDefault();
      }
    }).css('cursor','').focus();
    var range = document.createRange();
    range.selectNodeContents(theNode.get(0));
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  
    function onBlur(){
      let 
        metaId = theNode.metaId(),
        text = this.innerText.trim().replace(/\s+/g,' '),
        originalColor = ColorCache.get(metaId);
      if(!originalColor){
        //TODO send error to user but we caanot do anything
        ApiServer.webjslog("no color with metaId "+metaId);
      }else{
        //if the text has changed
        if(text!==originalColor.name){
          if(!text.length || text===originalColor.defaultName){
            //if it is the default one || empty, we delete
            ApiServer.colordelete(theNode.metaId(),function(){},display);
            ColorCache.invalidate()
          }else{
            //else we update the color
            ApiServer.colorput(new ApiServer.types.ColorInputBean({name:text,metaId:theNode.metaId()}));
            ColorCache.invalidate()
          }
        }
      }
      
    }
    
    theNode.on('keypress',function(evt){
      if([10,13].indexOf(evt.keyCode)!==-1){
        evt.stopPropagation();
        evt.preventDefault();
        onBlur.apply(this)
      }
    });
    theNode.on('blur',onBlur)
  })
  var defaultColor;
  form.on("pickedaccounts",function(evt,data){
    var 
      color,
      defaultColorNode = obj.find('li[data-color-default]'),
      
      isSelected = (defaultColorNode.css('background-color') === defaultColorNode.css('border-color'));
      
    defaultColor = defaultColor||defaultColorNode.attr('data-color');
      
    if(!data.isAll && data.accounts.length===1){
      color = data.accounts[0].color;
    }else{
      color = defaultColor
    }
    
    defaultColorNode.attr('data-color',color)
    defaultColorNode.css('border-color',color);
    if(isSelected){
      defaultColorNode.css('background-color',color);
    }
           
  })
}